import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const GaugeCorpDashboard = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chartRef = useRef(null);

  useEffect(() => {
    let chart = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.GaugeChart
    );
    if (props.labelText) {
      // gauge chart settings
      chart.innerRadius = -30;
      chart.marginTop = -100;

      // x.dateFormatter.inputDateFormat = "yyyy-MM-dd";

      // Normal axis
      let axis = chart.xAxes.push(new am4charts.ValueAxis());
      axis.min = 0;
      axis.max = 100;
      axis.strictMinMax = true;
      axis.renderer.grid.template.disabled = true;
      axis.renderer.grid.template.strokeOpacity = 0.3;
      axis.renderer.labels.template.disabled = true;

      // Range
      var range = axis.axisRanges.create();
      range.value = 0;
      range.endValue = 100;
      range.axisFill.fillOpacity = 1;
      range.axisFill.fill = props.barColor
        ? am4core.color(props.barColor)
        : "#ffcc00";

      // Main label
      var label = chart.radarContainer.createChild(am4core.Label);
      label.isMeasured = false;
      label.x = am4core.percent(50);
      label.y = am4core.percent(100);
      label.horizontalCenter = "middle";
      label.verticalCenter = "bottom";
      label.fontSize = props.labelFontSize;
      label.text = props.labelText;
      label.fill = props.labelColor;

      // Hand
      // var hand = chart.hands.push(new am4charts.ClockHand());
      // hand.axis = axis;
      // hand.innerRadius = am4core.percent(30);
      // hand.startWidth = 20;
      // hand.pin.disabled = true;
      // hand.value = props.labelText ? props.labelText : 50;
      // hand.fill = am4core.color("#b1b0b5");
      // hand.stroke = am4core.color("#b1b0b5");

      var hand = chart.hands.push(new am4charts.ClockHand());
      hand.axis = axis;
      // hand.innerRadius = props.graphSetting.numbeOfGraph > 5 ? 5 : 30;
      // hand.startWidth = props.graphSetting.numbeOfGraph > 5 ? 5 : 10;
      hand.innerRadius = am4core.percent(30);
      hand.radius = am4core.percent(75);
      hand.width = "15px";
      hand.pin.disabled = true;
      // hand.value = props.labelText ? props.labelText : 10;
      hand.value = props.valPerc;
      
      // hand.fill = am4core.color("#b1b0b5");
      // hand.stroke = am4core.color("#b1b0b5");
      hand.fill = am4core.color("lightgrey");
      hand.stroke = am4core.color("lightgrey");

      chartRef.current = chart;
    }

    return () => {
      chart.dispose();
    };
  });

  return (
    <div>
      {props.labelText ? (
        <div
          id={props.divId ? props.divId : "DivID"}
          style={{
            width: props.chartDivWidth,
            height: props.chartDivHeight,
            borderRadius: props.chartDivBorderRadius,
            marginLeft: "0px",
            // boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",

          }}
        ></div>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default GaugeCorpDashboard;
